import { render, staticRenderFns } from "./adjust_table.vue?vue&type=template&id=60c75019&scoped=true&"
import script from "./adjust_table.vue?vue&type=script&lang=js&"
export * from "./adjust_table.vue?vue&type=script&lang=js&"
import style0 from "./adjust_table.vue?vue&type=style&index=0&id=60c75019&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c75019",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60c75019')) {
      api.createRecord('60c75019', component.options)
    } else {
      api.reload('60c75019', component.options)
    }
    module.hot.accept("./adjust_table.vue?vue&type=template&id=60c75019&scoped=true&", function () {
      api.rerender('60c75019', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/fee/views/record_manage/discount_cost_pool/form/components/adjust_table.vue"
export default component.exports